<template>
  <!-- CRM申请列表 -->
  <div class="crm-search">
    <a-card style="margin-bottom: 10px">
      <search-view
        ref="searchView"
        :renderItem="CRM_SEARCH_SCHEMA"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button type="primary" icon="download" @click="downloadTable">
          下载表格
        </a-button>
      </div>
      <table-view
        bordered
        :data="tableData"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="SCROLL"
        @handlePagination="handlePagination"
      >
        <template v-slot:applyAmount="{ tableRow }">
          <span v-html="$formatAppAmount(tableRow.applyAmount)"></span>
        </template>

        <template v-slot:approveAmount="{ tableRow }">
          <span v-html="$formatAppAmount(tableRow.approveAmount)"></span>
        </template>

        <template v-slot:type="{ tableRow }">
          <span>{{ CREDIT_TYPE_OBJ[tableRow.type] }}</span>
        </template>

        <template v-slot:status="{ tableRow }">
          <a-tag
            :color="STATUS_OBJ[tableRow.status].color"
            style="width: 70px; text-align: center;"
          >
            {{ STATUS_OBJ[tableRow.status].label }}
          </a-tag>
        </template>
        <template v-slot:amountFinalStr="{ tableRow }">
          <div
            v-for="(item, index) in $formatStrList2Arr(tableRow.amountFinalStr)"
            :key="index"
          >
            {{ item }}
          </div>
        </template>
        <template v-slot:termStr="{ tableRow }">
          <div
            v-for="(item, index) in $formatStrList2Arr(tableRow.termStr)"
            :key="index"
          >
            {{ item }}
          </div>
        </template>
        <template v-slot:action="{ tableRow }">
          <a-button type="link" size="small" @click="handleView(tableRow)">
            查看
          </a-button>
        </template>
      </table-view>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import cloneDeep from 'lodash/cloneDeep'
import { CRM_SEARCH_SCHEMA } from './schema'
import { getCrmApplyList, downloadCrmTable } from './api'
import { formatParamDate } from 'utils/util'
import { CREDIT_TYPE_OBJ } from '../const'
import { STATUS_OBJ } from './const'

export default {
  name: 'crm-search',
  data() {
    const initSearchForm = {
      companyName: '',
      companyCode: '',
      endTime: '',
      startTime: '',
      status: '',
    }
    const searchForm = cloneDeep(initSearchForm)
    return {
      STATUS_OBJ,
      CRM_SEARCH_SCHEMA,
      CREDIT_TYPE_OBJ,
      tableLoading: false,
      initSearchForm,
      searchForm,
      tableData: [],
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
          width: 80,
          fixed: 'left',
        },
        {
          title: '申请流水号',
          dataIndex: 'sn',
          width: 200,
        },
        {
          title: '企业名称',
          dataIndex: 'companyName',
          width: 250,
        },
        {
          title: '企业ID',
          dataIndex: 'companyCode',
          width: 150,
        },
        {
          title: '专项凭证号',
          customRender: (text, record) => {
            return record.specialNo.join(', ')
          },
          width: 150,
        },
        {
          title: 'Financialtransaction',
          customRender: (text, record) => {
            return record.numNo.join(', ')
          },
          width: 160,
        },
        {
          title: '申请日期',
          dataIndex: 'applyDate',
          width: 150,
        },
        {
          title: '信用类型',
          scopedSlots: { customRender: 'type' },
          width: 180,
        },
        {
          title: '申请金额(元)',
          scopedSlots: { customRender: 'applyAmount' },
          width: 200,
        },
        {
          title: '审批金额(元)',
          scopedSlots: { customRender: 'approveAmount' },
          width: 200,
        },
        {
          title: '账期(天)',
          width: 100,
          scopedSlots: { customRender: 'termStr' },
        },
        {
          title: '申请后总限额/额度(元)',
          scopedSlots: { customRender: 'amountFinalStr' },
          width: 200,
        },
        {
          title: '业务类型',
          dataIndex: 'business',
          width: 100,
        },
        {
          title: '业务模式',
          dataIndex: 'model',
          width: 100,
        },
        {
          title: '当前审批人',
          dataIndex: 'approveRole',
          width: 120,
        },
        {
          title: '状态',
          scopedSlots: { customRender: 'status' },
          width: 100,
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 100,
          fixed: 'right',
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      SCROLL: { x: 2300 },
    }
  },
  mounted() {
    this._getCrmApplyList(this.initSearchForm)
  },
  methods: {
    async _getCrmApplyList(searchForm) {
      if (this.tableLoading) {
        return
      }
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...searchForm,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getCrmApplyList(formData)
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    handleSearch(data) {
      data = formatParamDate(data, data.applyRangeDate)
      delete data.applyRangeDate
      this.searchForm = data
      this.pageData.current = 1 // 设置为第一页
      this._getCrmApplyList(data)
    },
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getCrmApplyList(this.searchForm)
    },

    handleView(row) {
      const { id, type, status } = row
      this.$router.push({
        path: `/credit-approval/apply-detail/${id}`,
        query: {
          type,
          status,
        },
      })
    },
    async downloadTable() {
      try {
        await downloadCrmTable(this.searchForm)
      } catch (error) {
        console.error(error)
      }
    },
  },
  components: {
    SearchView,
    TableView,
  },
}
</script>

<style></style>
